import { Button } from "@mantine/core"
import { CenteredMessage } from "atlas_forecasting_app/components/common/page_elements"
import { RouterLink } from "atlas_forecasting_app/lib/router"

export function NotFoundPage() {
  return (
    <CenteredMessage
      eyebrow="Navigation"
      variant="editorial"
      title="Not found"
      body="That page doesn’t exist or is no longer available."
      action={
        <Button component={RouterLink} to="/">
          Go home
        </Button>
      }
    />
  )
}
